import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './services/auth.service';
import { JwtUtils } from './jwtUtils';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router, private jwtUtils: JwtUtils) { }

  private readonly allowedRoutes: string[] = ['/dashboard', '/about', '/contact'];

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
  
    const token = localStorage.getItem('access_token');
    
    if (!token || this.jwtUtils.isTokenExpired(token)) {
      this.router.navigate(['/login']);
      return false;
    }

    // Check if the user is logged in
    // if (this.authService.isLoggedIn()) {
    //   // Check if the route is included in the allowedRoutes array
    //   if (this.allowedRoutes.includes(state.url)) {
    //     return true;
    //   }
    //   // Check if the user has the admin role
    //   if (this.authService.getUserRole() !== "" && this.authService.getUserRole().includes('admin')) {
    //     return true;
    //   } else {
    //     // Redirect to a different page or show an error message
    //     this.router.navigate(['/unauthorized']);
    //     return false;
    //   }
    // }
  
    return true;
  }
  

}
